function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import labels from '../locale/en.json';
import { metadata as metadataPropType, labels as labelsPropType } from './PropTypes';
import PhoneInput from './PhoneInputWithCountry';
export function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = React.forwardRef(function (props, ref) {
    return React.createElement(PhoneInput, _extends({
      ref: ref
    }, props));
  });
  PhoneInputDefault.propTypes = {
    metadata: metadataPropType.isRequired,
    labels: labelsPropType.isRequired
  };
  PhoneInputDefault.defaultProps = {
    metadata: defaultMetadata,
    labels: labels
  };
  return PhoneInputDefault;
}
export default createPhoneInput();
//# sourceMappingURL=PhoneInputWithCountryDefault.js.map